import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import GeoPoint from "@/models/Shared/GeoPoint";

export default class CreateCompanyAddressRequest extends BaseUpdateRequest {
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    types: string[] = [];
}